<template>
    <div class="topleft_wrap">
        <div class="topleft_wrap_title">工单产出分析 <span style="font-size:14px">近10天</span></div>
        <div class="topleft_wrap_block1">
            <div id="leftChart1"></div>
        </div>
        <div class="topleft_wrap_block2">
            <div id="leftChart2"></div>
        </div>
    </div>
</template>

<script>
import { orderAnalysis} from '@/api/basicData';
export default {
    data() {
        return {
            chart1: null,
            chart2: null,
            userData:JSON.parse(window.localStorage.getItem('userdata')),
            finishOrder:[],
            orderData:[],
            option:{},
            option2:{},
            tenDays:[],
            monthArray:[],
            estimateSalary:[],
            salaryName:[],
        }
    },
    created(){
    },
    mounted() {
      this.getOrderAnalysis()
      this.initChart1()
      this.initChart2()
    },
    methods: {
      formatterDate(day){
        console.log(this.tenDays);
        return this.tenDays[day-1]
      },
        initChart1() {
          var _this = this
            this.chart1 = this.$echarts.init(document.getElementById("leftChart1"));
            this.option2 = {
                tooltip: {
                trigger: 'axis',
                axisPointer: {
                    type: 'shadow'
                }
                },
                title: [
                {
                    text: '工单产出趋势图('+ this.monthArray.join(' 至 ') +')',
                    left: '0%',
                    top: '0',
                    textStyle: {
                    fontSize: 14,
                    fontWeight: 'normal',
                    color: '#fff'
                    }
                }
                ],
                tooltip: {
                  trigger: "axis",
                  formatter: function (params) {
                    var result = ''
                    params.forEach(function (item) {
                      if(item.seriesName == '完成工单'){
                        result += _this.formatterDate(item.axisValue) + "</br>"
                      }else{
                        result += "</br>"
                      }
                      result += item.marker + item.seriesName + ':' +  item.data
                    })
                    return result
                  },
                },
                grid: {
                left: '5%',
                right: '4%',
                bottom: '0%',
                containLabel: true
                },
                legend: {
                    orient: 'horizontal',
                    right: '20%',
                    y: '0',
                    itemWidth: 16, // 设置图例图形的宽
                    itemHeight: 16, // 设置图例图形的高
                    textStyle: {
                        color: '#fff' // 图例文字颜色
                    },
                    // itemGap设置各个item之间的间隔，单位px，默认为10，横向布局时为水平间隔，纵向布局时为纵向间隔
                    itemGap: 10,
                    // data: ['完成工单', '工单产出']
                    data: ['完成工单']
                },
                xAxis: [
                {
                    type: 'category',
                    boundaryGap: ['0%', '10%'],
                    data: ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10"],
                    axisTick: {
                        show: false,
                    },
                    axisLine: {
                        show: true,
                        lineStyle: {
                        color: "#232447",
                        }
                    },
                    axisLabel: {
                        show: true,
                        margin: 5, //刻度标签与轴线之间的距离
                        textStyle: {
                        color: "#9a99a8",
                        },
                    },
                }
                ],
                yAxis: [
                {
                    type: 'value',
                    name: '完成工单',
                    position: 'left',
                    nameTextStyle: {
                    padding: [0, 0, 0, -40] // 四个数字分别为上右下左与原位置距离
                    },
                    nameGap: 10, // y轴name与横纵坐标轴线的间距
                    nameLocation: 'end', // y轴name处于y轴的什么位置
                    silent: false,
                    clickable: true,
                    alignTicks: true,
                    splitLine: {
                        show: true,
                        lineStyle: {
                        color: "#686a75",
                        type: "dashed",
                        }
                    },
                    axisTick: {
                        show: false,
                    },
                    axisLine: {
                        show: false,
                        lineStyle: {
                        color: "#686a75",
                        }
                    },
                    axisLabel: {
                        show: true,
                        formatter: '{value}',
                        textStyle: {
                        color: "#686a75"
                        }
                    },
                },
                {
                    type: 'value',
                    name: '工单产出',
                    nameTextStyle: {
                    padding: [0, -40, 0, 0] // 四个数字分别为上右下左与原位置距离
                    },
                    nameGap: 10, // y轴name与横纵坐标轴线的间距
                    nameLocation: 'end', // y轴name处于y轴的什么位置
                    position: 'right',
                    alignTicks: true,
                    splitLine: {
                        show: false,
                    },
                    axisTick: {
                        show: false,
                    },
                    axisLine: {
                        show: false,
                        lineStyle: {
                        color: "#686a75",
                        }
                    },
                    axisLabel: {
                        show: true,
                        formatter: '{value}',
                        textStyle: {
                        color: "#686a75"
                        }
                    },
                }
                ],
                dataZoom: [
                    {
                        orient: "horizontal",
                        show: false, //控制滚动条显示隐藏
                        realtime: true, //拖动滚动条时是否动态的更新图表数据
                        end: 100, //滚动条结束位置
                        start: 0, //滚动条开始位置
                        zoomLock: true, //控制面板是否进行缩放
                    },
                    {
                        type: 'inside', //鼠标滚轮
                        realtime: true,
                    }
                ],
                series: [
                {
                    name: '完成工单',
                    type: 'bar',
                    data: this.finishOrder,
                    barWidth: '12',
                    itemStyle: {
                    normal: {
                        color: '#1cc0f2'
                    }
                    }
                },
                // {
                //     name: '工单产出',
                //     type: 'line',
                //     yAxisIndex: 1,
                //     data: this.orderData,
                //     itemStyle: {
                //         normal: {
                //             color: '#7cfcb2'
                //         }
                //     }
                // }
                ]
            }
            this.chart1.setOption(this.option2);
            let that = this;
            window.addEventListener("resize", function () {
                that.chart1.resize();
            });
        },
        initChart2() {
            this.chart2 = this.$echarts.init(document.getElementById("leftChart2"));
            this.option = {
                tooltip: {
                trigger: 'axis',
                axisPointer: {
                    type: 'shadow'
                }
                },
                title: [
                {
                    text: '员工绩效TOP5',
                    left: '0%',
                    top: '0',
                    textStyle: {
                    fontSize: 14,
                    fontWeight: 'normal',
                    color: '#fff'
                    }
                }
                ],
                grid: {
                    top: '15%',
                    left: '1%',
                    right: '9%',
                    bottom: '0',
                    containLabel: true
                },
                legend: {
                orient: 'horizontal',
                right: 'center',
                y: '0',
                itemWidth: 16, // 设置图例图形的宽
                itemHeight: 16, // 设置图例图形的高
                textStyle: {
                    color: '#fff' // 图例文字颜色
                },
                // itemGap设置各个item之间的间隔，单位px，默认为10，横向布局时为水平间隔，纵向布局时为纵向间隔
                itemGap: 10,
                data: []
                },
                yAxis: {
                    data: this.salaryName,
                    axisTick: {
                        show: false,
                    },
                    axisLine: {
                        show: true,
                        lineStyle: {
                        color: "#232447",
                        }
                    },
                    axisLabel: {
                        show: true,
                        margin: 10, //刻度标签与轴线之间的距离
                        textStyle: {
                        color: "#9a99a8",
                        },
                    },
                },
                xAxis: {
                name:'',
                nameTextStyle:{
                    color: '#44c88d',
                },
                splitLine: {
                    show: true,
                    lineStyle: {
                    color: "#232447",
                    type: "dashed",
                    }
                },
                axisTick: {
                    show: false,
                },
                axisLine: {
                    show: true,
                    lineStyle: {
                    color: "#232447",
                    }
                },
                axisLabel: {
                    show: true,
                    textStyle: {
                    color: "#7c7b8e"
                    }
                },
                },
                dataZoom: [
                    {
                        orient: "horizontal",
                        show: false, //控制滚动条显示隐藏
                        realtime: true, //拖动滚动条时是否动态的更新图表数据
                        end: 100, //滚动条结束位置
                        start: 0, //滚动条开始位置
                        zoomLock: true, //控制面板是否进行缩放
                    },
                    {
                        type: 'inside', //鼠标滚轮
                        realtime: true,
                    }
                ],
                series: [
                {
                    name: '产出',
                    type: 'bar',
                    data: this.estimateSalary,
                    barWidth: '10',
                    itemStyle: {
                    normal: {
                        color: '#2bc7f3'
                    }
                    }
                },
                ]
            }
            this.chart2.setOption(this.option,true);
            let that = this;
            window.addEventListener("resize", function () {
                that.chart2.resize();
            });
        },
        async getOrderAnalysis(){
          var data = {
            factoryId:this.userData.factoryId
          }
          await orderAnalysis(data).then(res => {
            if(res.code == 200){
              var aggEnter = res.data.aggEnter
              var aggOrder = res.data.aggOrder
              var aggSalary = res.data.aggSalary
              if(aggOrder && aggOrder.length!=0){
                this.orderData = aggOrder.map(function(item){return item.goodNum})
                this.tenDays = aggOrder.map(function(item){return item.actualEndDate})
                var tenDays = JSON.parse(JSON.stringify(this.tenDays))
                this.monthArray = []
                tenDays.map(function(item){
                  var tem = item.substring(0,7)
                  if(this.monthArray.indexOf(tem) == -1){
                    this.monthArray.push(tem)
                  }
                }.bind(this))
              }
              if(aggOrder && aggOrder.length!=0){
                this.finishOrder = aggOrder.map(function(item){return item.completedNum})
              }
              if(aggSalary && aggSalary.length!=0){
                this.estimateSalary = []
                this.salaryName = []
                aggSalary.map(function(item){
                  if(item.name){
                    this.estimateSalary.push(item.totalGoodNum)
                    this.salaryName.push(item.name)
                  }
                }.bind(this))
              }
              this.initChart1()
              this.initChart2()
            }else{
              this.$message.error('查询失败！')
            }
            this.loading = false
          })
          .catch(err => {
            this.loading = false
            this.$message.error(err)
          })
        },

    }
}
</script>

<style scoped>
.topleft_wrap{
    width: 100%;
    height: 100%;
    padding: 2%;
    color: #fff;
    font-size: 12px;
    box-sizing: border-box;
}
.topleft_wrap_title {
    width: 95%;
    color: #04f9fe;
    font-size: 16px;
    margin-top: 5px;
    margin-bottom: 10px;
    margin-left: 10px;
    padding-bottom: 5px;
    font-weight: 600;
    border-bottom: 1px solid rgba(4,249,254,.4);
}
.topleft_wrap_block1 {
    height: 45%;
    width: 95%;
    margin-bottom: 10px;
    padding-bottom: 5px;
    margin-left: 10px;
    border-bottom: 1px solid rgba(4,249,254,.4);
}
.topleft_wrap_block2 {
    height: 41%;
    width: 100%;
    margin-bottom: 10px;
    padding-bottom: 5px;
    margin-left: 10px;
}
#leftChart1 {
    height: 100%;
    width: 100%;
}
#leftChart2 {
    height: 100%;
    width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/views/workshopSignage/workshopSignage/components/topleft.vue